module.exports = __webpack_public_path__ + "img/imgZXGH(28).9b47647e.png";